/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable arrow-body-style */
/* eslint-disable react/function-component-definition */
/* eslint-disable consistent-return */
/* eslint-disable react/no-array-index-key */
/* eslint-disable import/extensions */
import { useState } from 'react';
import styled from '@emotion/styled';
import {
  spacing,
  breakpoints,
  palette,
  Typography,
  Button,
  fontStyle,
} from '@playdapp/ui';
import { useInfiniteQuery } from 'react-query';

import { useAppSelector } from 'store/hooks';
import useTokenCurrency from 'hooks/useTokenCurrency';
import { getMyFavorite } from 'api/user';

import { CardListBox } from 'styles/pages/collection';
import { times } from 'lodash';
import { useMedia } from 'react-use';
import { getBreakpointQuery, numberToAbbreviateString } from 'lib/util';
import EmptyItem from './EmptyItem';
import SortByDropDown from './SortByDropDown';
import Card from './Card';
import MetaTag from './MetaTag';
import ErrorContents from './ErrorContents';

type Favorite = {
  title: string;
  value: string;
};

const SelectOptionArea = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  width: 100%;
  height: ${({ theme }) => theme.rem(48)};
  margin-bottom: ${spacing.xl};

  ${breakpoints.down('md')} {
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
    height: auto;
    margin-bottom: 1rem;
  }
`;

const OfferEventDrop = styled(SortByDropDown)`
  position: relative;
  align-items: flex-end;
  ${fontStyle('b4')};

  ${breakpoints.down('lg')} {
    display: none;
  }
`;

const MobileOfferEventDrop = styled(SortByDropDown)`
  display: none;

  ${breakpoints.down('lg')} {
    display: block;
    align-items: flex-end;
    width: 100%;
    max-width: ${({ theme }) => theme.rem(200)};
    order: 2;
  }

  ${breakpoints.down('md')} {
    display: block;
    align-items: flex-end;
    width: 100%;
    max-width: 100%;
    order: 1;

    div {
      ${fontStyle('p3')};
    }
  }
`;

const ContentBody = styled.div`
  width: 100%;
  min-height: ${({ theme }) => theme.rem(540)};
`;

const DropDownSortContent = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: ${spacing.xs};
  padding: 0;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
`;

const SelectBundleArea = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex: auto;
  text-align: center;

  ${breakpoints.down('md')} {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-bottom: ${spacing.m};
    order: 1;
  }
`;

const CollectionLink = styled.div`
  display: flex;
  justify-content: flex-start;
  width: 100%;
  padding: ${spacing.s} ${spacing.l};
  ${fontStyle('p4')};
  border: none;
  cursor: pointer;

  & > span {
    flex: none;
  }

  &:first-of-type {
    border-top-left-radius: ${spacing.xs};
    border-top-right-radius: ${spacing.xs};
  }

  &:last-of-type {
    border-bottom-left-radius: ${spacing.xs};
    border-bottom-right-radius: ${spacing.xs};
  }

  p {
    margin-left: ${spacing.s};
    padding-top: 1px;
    margin-bottom: -1px;
  }

  &:hover {
    background-color: ${palette.gray300};
  }

  ${breakpoints.down('md')} {
    ${fontStyle('p3')};
  }
`;

const CategoryListBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const LoadMore = styled(Button)`
  display: flex;
  align-items: center;
  margin: ${spacing.l} auto;

  :hover {
    background: rgba(43, 202, 176, 0.08);
  }

  & + a,
  a + & {
    margin-left: ${spacing.xs};
  }
`;

const EmptyItemBlock = styled.div`
  margin-top: 10rem;
`;

const MyFavorite = () => {
  const [isClose, setIsClose] = useState(true);
  const [collection, setCollection] = useState({
    title: 'Recently Added',
    value: 'recent',
  });
  const [filter, setFilter] = useState<string>('recent');
  const isMobile = useMedia(getBreakpointQuery(breakpoints.down('md')), false);

  const { account } = useAppSelector(({ wallet }) => wallet);
  const { email } = useAppSelector(({ user }) => user);

  const { convertToUsd } = useTokenCurrency();

  const fetchFavoriteList = async ({ pageParam = 1 }) => {
    if (!account) {
      throw new Error('No account');
    }

    const { data } = await getMyFavorite({
      email,
      page: pageParam,
      filter,
      isBundle: 0,
    });

    return { ...data, from: pageParam, nextPage: pageParam + 1 };
  };

  const { isLoading, data, fetchNextPage, hasNextPage, error } =
    useInfiniteQuery(['myFavorite', account, filter], fetchFavoriteList, {
      getNextPageParam: (lastPage) => {
        if (lastPage.count && lastPage.count > lastPage.from + 10) {
          return lastPage.nextPage;
        }
      },
      enabled: !!account && !!email,
      cacheTime: 0,
      refetchOnWindowFocus: false,
    });

  const handleFavorite = (collectionFavoriteParam: Favorite) => {
    if (collection.value !== collectionFavoriteParam.value) {
      setCollection(collectionFavoriteParam);
    }

    setFilter(collectionFavoriteParam.value);
    setIsClose(true);
  };

  const handleLoadMore = () => {
    fetchNextPage();
  };

  return (
    <>
      <MetaTag title="My Favorite | PlayDapp" />
      <SelectOptionArea>
        <SelectBundleArea>
          <OfferEventDrop
            title={collection.title}
            collectionName="all"
            width="262"
            height="36"
            top="48"
            isBorder
            isDropBox
            floatingContent
            isClose={isClose}
          >
            <DropDownSortContent>
              <CategoryListBlock>
                <CollectionLink
                  onClick={() => {
                    handleFavorite({
                      title: 'Recently Added',
                      value: 'recent',
                    });
                  }}
                >
                  Recently Added
                </CollectionLink>
                <CollectionLink
                  onClick={() => {
                    handleFavorite({
                      title: 'Most Favorite',
                      value: 'count',
                    });
                  }}
                >
                  Most Favorite
                </CollectionLink>
              </CategoryListBlock>
            </DropDownSortContent>
          </OfferEventDrop>

          <MobileOfferEventDrop
            title={collection.title}
            width="100%"
            height="40"
            top="40"
            isBorder
            isDropBox
            floatingContent
            isMobile
          >
            <DropDownSortContent>
              <CategoryListBlock>
                <CollectionLink
                  onClick={() => {
                    handleFavorite({
                      title: 'Recently Added',
                      value: 'recent',
                    });
                  }}
                >
                  Recently Added
                </CollectionLink>
                <CollectionLink
                  onClick={() => {
                    handleFavorite({
                      title: 'Most Favorite',
                      value: 'count',
                    });
                  }}
                >
                  Most Favorite
                </CollectionLink>
              </CategoryListBlock>
            </DropDownSortContent>
          </MobileOfferEventDrop>
        </SelectBundleArea>
      </SelectOptionArea>

      <ContentBody>
        <CardListBox>
          {isLoading && times(30, (index) => <Card key={index} isLoading />)}

          {data?.pages.map((items) => {
            const { list } = items;
            return list?.map(
              (
                {
                  name,
                  imageUri,
                  tokenId,
                  network,
                  assetAddress,
                  owner,
                  order,
                  likeCount,
                },
                index,
              ) => (
                <Card
                  key={`${name}_${tokenId}-${index}`}
                  imageUri={imageUri}
                  tokenId={tokenId}
                  name={name}
                  order={order}
                  convertedPrice={convertToUsd(
                    order.sale?.price,
                    network,
                    order.sale?.currency,
                  )}
                  network={network}
                  href={`/item/${network}/${assetAddress}/${tokenId}`}
                  assetAddress={assetAddress}
                  isOwner={owner === account}
                  isBundle={false}
                  like={numberToAbbreviateString(likeCount)}
                />
              ),
            );
          })}
        </CardListBox>

        {hasNextPage && (
          <LoadMore
            color="primary"
            size="md"
            variant="outline"
            onClick={handleLoadMore}
          >
            <Typography color="primary700" type={isMobile ? 'b4' : 'b3'}>
              Load more +
            </Typography>
          </LoadMore>
        )}

        {!error &&
          data?.pages &&
          data?.pages.length > 0 &&
          data?.pages[0].count === 0 && (
            <EmptyItemBlock>
              <EmptyItem />
            </EmptyItemBlock>
          )}

        {!isLoading && error && (
          <EmptyItemBlock>
            <ErrorContents />
          </EmptyItemBlock>
        )}
      </ContentBody>
    </>
  );
};

export default MyFavorite;
